import { __assign } from "tslib";
import { componentMap as PCComponentMap } from '@cainiaofe/cn-ui';
import CnAddress from '@cainiaofe/cn-address';
console.log('PCComponentMap', PCComponentMap);
export var componentMap = __assign(__assign({}, PCComponentMap), { 
    // pc与移动组件名不一致
    CnDateRangePickerPro: PCComponentMap.CnRangeDatePicker2, CnAddressM: CnAddress, CnOSSImageUpload: PCComponentMap.CnOSSUpload });
